<template>
  <div id="app">
    <router-view v-if="isReloadAlive"></router-view>
  </div>
</template>

<script>
import { PostData, GetData } from "@/api";
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReloadAlive: true,
      noSaveUserCommonModules: [
        "AIWORK_GZT_91010000",
        "ShowClientWeb",
        "LookEvidence",
        "repair",
        "carInfo",
      ],
    };
  },

  watch: {
    $route(to, from) {
      if (
        to.name != "login" &&
        this.noSaveUserCommonModules.indexOf(to.name) == -1 &&
        location.href.indexOf("noTop") == -1 &&
        location.href.indexOf("onepage") == -1
      ) {
        var list = window.LastMenu || [];
        var obj = list.find((v) => {
          return v.rightId == to.meta.RightId;
        });
        if (!obj) {
          this.SaveUserCommonModules(to);
        }
      }
    },
  },
  created() {
    window.STrouter = this.$router;
    // a8e452d866368b6ae184800e84b9a487 4636e5c270e7bad9f4cfca0976726b6c 0f1d4202a434e900a7772b5b401c7f7d a8e452d866368b6ae184800e84b9a487
    // $.getScript(
    //   "https://webapi.amap.com/maps?v=1.4.15&key=a8e452d866368b6ae184800e84b9a487&plugin=AMap.MouseTool,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.PolyEditor,AMap.CircleEditor,AMap.RectangleEditor,AMap.MarkerClusterer,AMap.RangingTool",
    //   () => {}
    // );
  },
  mounted() {
    if (top == self) {
      // console.log('message')
      window.addEventListener(
        "message",
        (e) => {
          // console.log(e);
          var params = e.data;
          if (!params.name) return;
          this.$router.push(params);
        },
        false
      );
    }
  },
  methods: {
    async SaveUserCommonModules(datas) {
      try {
        let { data } = await PostData(
          StarSoft.SysInfo.HttpMainUrl +
            "api/AIWorkBenchMgr/AIWorkBench/SaveUserCommonModules",
          null,
          {
            rightCode: datas.meta.RightCode,
            rightId: datas.meta.RightId,
          }
        );
        if (data.Suc) {
        }
      } catch (error) {
        console.error(error);
      }
    },
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(function () {
        this.isReloadAlive = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .no_sty .el-input__inner {
  // border: 1px solid white;
  // padding: 0;
  font-size: 14px;
  color: #000;
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
</style>
